export const OPERATOR_TYPES_1 = [
  {
    value: 'equal_to',
    label: 'Equal to',
  },
  {
    value: 'not_equal_to',
    label: 'Not equal to',
  },
];

export const OPERATOR_TYPES_2 = [
  {
    value: 'equal_to',
    label: 'Equal to',
  },
  {
    value: 'not_equal_to',
    label: 'Not equal to',
  },
  {
    value: 'contains',
    label: 'Contains',
  },
  {
    value: 'does_not_contain',
    label: 'Does not contain',
  },
];

export const OPERATOR_TYPES_3 = [
  {
    value: 'equal_to',
    label: 'Equal to',
  },
  {
    value: 'not_equal_to',
    label: 'Not equal to',
  },
  {
    value: 'is_present',
    label: 'Is present',
  },
  {
    value: 'is_not_present',
    label: 'Is not present',
  },
];

export const OPERATOR_TYPES_4 = [
  {
    value: 'equal_to',
    label: 'Equal to',
  },
  {
    value: 'not_equal_to',
    label: 'Not equal to',
  },
  {
    value: 'is_present',
    label: 'Is present',
  },
  {
    value: 'is_not_present',
    label: 'Is not present',
  },
  {
    value: 'is_greater_than',
    label: 'Is greater than',
  },
  {
    value: 'is_less_than',
    label: 'Is less than',
  },
];

export const OPERATOR_TYPES_5 = [
  {
    value: 'is_greater_than',
    label: 'Is greater than',
  },
  {
    value: 'is_less_than',
    label: 'Is less than',
  },
  {
    value: 'days_before',
    label: 'Is x days before',
  },
];

export const OPERATOR_TYPES_6 = [
  {
    value: 'equal_to',
    label: 'Equal to',
  },
  {
    value: 'not_equal_to',
    label: 'Not equal to',
  },
  {
    value: 'contains',
    label: 'Contains',
  },
  {
    value: 'does_not_contain',
    label: 'Does not contain',
  },
  {
    value: 'starts_with',
    label: 'Starts With',
  },
  {
    value: 'is_present',
    label: 'Is present',
  },
  {
    value: 'is_not_present',
    label: 'Is not present',
  },
];
// The operators a submitted answer offers, picked by the type of the form field it belongs to.
export const FORM_FIELD_TEXT_OPERATORS = [
  {
    value: 'equal_to',
    label: 'Is',
  },
  {
    value: 'not_equal_to',
    label: 'Is not',
  },
  {
    value: 'contains',
    label: 'Contains',
  },
  {
    value: 'does_not_contain',
    label: 'Does not contain',
  },
  {
    value: 'is_empty',
    label: 'Is empty',
  },
  {
    value: 'is_not_empty',
    label: 'Is not empty',
  },
];

export const FORM_FIELD_NUMBER_OPERATORS = [
  {
    value: 'equal_to',
    label: 'Is',
  },
  {
    value: 'not_equal_to',
    label: 'Is not',
  },
  {
    value: 'is_greater_than',
    label: 'Greater than',
  },
  {
    value: 'is_less_than',
    label: 'Less than',
  },
  {
    value: 'is_greater_than_or_equal_to',
    label: 'Greater than or equal to',
  },
  {
    value: 'is_less_than_or_equal_to',
    label: 'Less than or equal to',
  },
];

export const FORM_FIELD_SINGLE_SELECT_OPERATORS = [
  {
    value: 'equal_to',
    label: 'Is',
  },
  {
    value: 'not_equal_to',
    label: 'Is not',
  },
];

export const FORM_FIELD_MULTI_SELECT_OPERATORS = [
  {
    value: 'contains',
    label: 'Contains',
  },
  {
    value: 'does_not_contain',
    label: 'Does not contain',
  },
  {
    value: 'is_empty',
    label: 'Is empty',
  },
  {
    value: 'is_not_empty',
    label: 'Is not empty',
  },
];

export const OPERATOR_TYPES_7 = [
  {
    value: 'equal_to',
    label: 'Equal to',
  },
  {
    value: 'not_equal_to',
    label: 'Not equal to',
  },
  {
    value: 'is_present',
    label: 'Is present',
  },
  {
    value: 'is_not_present',
    label: 'Is not present',
  },
  {
    value: 'changed_to',
    label: 'Changed to',
  },
];
